import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { openNotification } from 'src/components/helpers/notification';
import ax from 'src/store/config';
import axFile from 'src/store/configFile';


const initialState = {
    stocksList: null,
    stocksListLoading: false
};

export const stocksAction = createAsyncThunk('stocksAction', async (payload, { dispatch }) => {
    dispatch(setStocksListLoading(true))
    try {
        let data;
        const url = '/api/admin/directory/stocks';
        switch (payload.flag) {
            case 'get':
                ({ data } = await ax.get(url, { params: payload.value }))
                data && dispatch(setStocksListLoading(false))
                return data

            case 'post':
                ({ data } = await axFile.post(url, payload.value))
                data && openNotification({
                    type: 'success',
                    message: `Акция успешно отредактирована`
                })
                break;

            case 'put':
                ({ data } = await axFile.put(url, payload.value))
                data && openNotification({
                    type: 'success',
                    message: `Акция успешно добавлена`
                })
                break;

            case 'delete':
                ({ data } = await ax.delete(url, { params: payload.value }))
                data && openNotification({
                    type: 'success',
                    message: `Акция успешно удалена`
                })
                break;

            default:
                break;
        }
    } catch (error) {
        dispatch(setStocksListLoading(false))
        openNotification({
            type: 'error',
            message: `Ошибка ${error.response.data.errorMessages[0].errorCode}. ${error.response.data.errorMessages[0].errorMessage}`
        })
        return error
    }
})

const StocksSlice = createSlice({
    name: 'stocks',
    initialState,
    reducers: {
        setStocksListLoading: (state, action) => {
            state.stocksListLoading = action.payload
        }
    },
    extraReducers: (builder) => {
        builder.addCase(stocksAction.fulfilled, (state, action) => {
            state.stocksList = action.payload
        })
    }
});

export const { setStocksListLoading } = StocksSlice.actions;

export default StocksSlice.reducer